import angular from 'angular';
import $ from 'jquery';

import { crl8 } from 'app/curalate.globals';

export default function bootstrapAsyncAngularApp() {
  // Execute after DOMContentLoaded via jquery callback
  $(() => {
    crl8.sessionPromise.then(() => {
      // Doing a setTimeout to make sure all other sessionPromise callbacks have been called
      // before this one. Damn jquery promises!
      setTimeout(() => {
        const rootElement = document.querySelector('[async-session-app]');

        // Legacy pages don't use async-session-app to boot, don't attempt if not found.
        if (rootElement) {
          const module = rootElement.getAttribute('async-session-app')!;
          angular.bootstrap(rootElement, [module]);
        }
      }, 4);
    });
  });
}
